import { SettingsBusinessFunctions } from './SettingsBusinessFunctions.tsx';
import { SettingsDerivedContexts } from './SettingsDerivedContexts.tsx';
import { SettingsEngineers } from './SettingsEngineers.tsx';

/**
 * /settings/setup — landing page for the catalog entities the matrices
 * are built from. Three stacked sections, each its own self-contained
 * component reading the Settings outlet context:
 *   - Business functions (Resilience matrix columns)
 *   - DerivedContexts (Resilience matrix rows)
 *   - Engineers (Talent matrix columns)
 *
 * Replaces the former standalone /settings/business-functions,
 * /settings/derivedContexts, and /settings/engineers tabs.
 */
export function SettingsSetup() {
  return (
    <div className="stack" style={{ display: 'flex', flexDirection: 'column', gap: '2.5rem' }}>
      <div>
        <h1 className="view-h1">Setup</h1>
        <p className="view-subtitle">
          Define the business functions, derivedContexts, and engineers your matrices are built from.
        </p>
      </div>
      <SettingsBusinessFunctions />
      <SettingsDerivedContexts />
      <SettingsEngineers />
    </div>
  );
}
